import { useDispatch, useSelector } from 'react-redux';
import { fetchEncryptedKeysThunk } from './KeysThunk';

export const useKeysStore = () => {
    const keys = useSelector((state) => state.keys);
    const dispatch = useDispatch();

    const fetchEncryptedKeys = () => {
        dispatch(fetchEncryptedKeysThunk());
    };

    return {
        keys: keys.keys || {},
        loading: keys.loading,
        error: keys.error,
        fetchEncryptedKeys
    };
};
